import { action, computed, observable } from 'mobx';
import { setter, toggle } from 'mobx-decorators';
import constants from 'Constants';
import { deserializeTimestamp, deserializeWithMappers, setFieldValues } from 'stores/Utils';



class ActivityStore {

  @setter @observable id;
  @setter @observable type;
  @setter @observable iconClass;
  @setter @observable desc;
  @setter @observable points;
  @setter @observable datetime;
  @setter @observable data;
  @setter @observable meta;

  static create(data={}) {
    const instance = new ActivityStore();
    setFieldValues(instance, data);
    return instance;
  }

  static getDefaults() {
    return {
      "id": null,
      "type": "",
      "iconClass": "",
      "desc": "",
      "points": "",
      "datetime": null,
      "data": {},
      "meta": {},
    };
  }

  constructor(defaults=ActivityStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  @action reset(defaults=ActivityStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  getDeserializeMappers() {
    return [
      {"field": "id"},
      {"field": "type"},
      {"field": "iconClass", "accessor": "icon_class"},
      {"field": "desc"},
      {"field": "points"},
      {"field": "datetime", "accessor": "timestamp", "type": constants.DESERIALIZE_TYPE_CUSTOM, "extract": deserializeTimestamp},
      {"field": "data"},
      {"field": "meta"},
    ];
  }

  @action async deserialize(data) {
    await deserializeWithMappers(this, this.getDeserializeMappers(), data);
  }

  @computed get isTypeEarnPoints() {
    return this.type === constants.REPERKS_ACTIVITY_TYPE_EARN_POINTS;
  }

  @computed get isTypeRedeemReward() {
    return this.type === constants.REPERKS_ACTIVITY_TYPE_REDEEM_REWARD;
  }


  @computed get isTypePointsAdjustment() {
    return this.type === constants.REPERKS_ACTIVITY_TYPE_POINTS_ADJUSTMENT;
  }

  @computed get name() {
    if (this.isTypeEarnPoints) return this.data.rule_name;
    if (this.isTypeRedeemReward) return this.data.reward_name;
    if (this.isTypePointsAdjustment) {
      if (this.data.use_custom_name && this.data.custom_name) return this.data.custom_name;
      return "Points Adjustment";
    }

    return '';
  }
}

export default ActivityStore;



